import { render, staticRenderFns } from "./ServerFile.vue?vue&type=template&id=ef31a64e&scoped=true"
import script from "./ServerFile.vue?vue&type=script&lang=js"
export * from "./ServerFile.vue?vue&type=script&lang=js"
import style0 from "./ServerFile.vue?vue&type=style&index=0&id=ef31a64e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef31a64e",
  null
  
)

export default component.exports